import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import logo from "../logo-light.svg";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-sm">
        <CardHeader className="items-center gap-4 text-center">
          <img src={logo} alt="Dolfin" className="mx-auto h-12 w-12" />
          <CardTitle className="text-2xl">Not found</CardTitle>
          <CardDescription>This link isn't valid. Check the URL or ask for a new one.</CardDescription>
        </CardHeader>
        <CardContent />
      </Card>
    </div>
  );
}
